export default __webpack_public_path__ + "static/media/character-4.baa9a408.png";